import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Loader = ({ showLoader, message, customStyles }) => {
  if (!showLoader) return null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      style={customStyles}
    >
      <CircularProgress size={50} thickness={5} />
      {message && (
        <Typography
          variant="body1"
          sx={{ marginTop: 2, color: 'text.secondary' }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default Loader;
